module.exports = __webpack_public_path__ + "static/images/pic160-160.b469d3f.jpg";